module.exports = __webpack_public_path__ + "img/tips1@x2.611cb193.png";